import { isPlatformBrowser } from '@angular/common';
import { Injectable,Inject, PLATFORM_ID} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: any) { }

  isBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  setItem(key: string, value: string) {
    if (this.isBrowser()) {
      localStorage.setItem(key, value);
    }
  }

  getItem(key: string) {
    if (this.isBrowser()) {
      return localStorage.getItem(key);
    }
    return null;
  }

  removeItem(key: string): void {
    if (this.isBrowser()) {
      localStorage.removeItem(key);
    }
  }

  clear(): void {
    if (this.isBrowser()) {
      localStorage.clear();
    }
  }
}
